import { ProfileState } from './profile.state';

export const profileGetters = {
  destinationAppUrl: (state: ProfileState) => state.destinationAppUrl
};
